import styled from 'styled-components';

import { Tag } from '@/shared/components/ui/tag/tag';

export const GroupInfoTag = styled(Tag)`
  && {
    margin: 0;
    width: 4rem;
  }
`;
